import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
export var SIZES = {
  xxs: 12,
  xs: 18,
  small: 24,
  base: 30,
  large: 40
};
var CLASSNAMES = {
  xxs: 'font-size-smaller',
  xs: 'font-size-smaller',
  small: 'font-size-normal',
  base: 'font-size-large',
  large: 'font-size-larger'
};
var STYLES = Object.keys(SIZES).reduce(function (styles, size) {
  return _objectSpread({}, styles, _defineProperty({}, size, {
    height: SIZES[size],
    width: SIZES[size]
  }));
}, {});

function getClassNamesForProps(props) {
  var url = props.url,
      size = props.size,
      className = props.className,
      _props$square = props.square,
      square = _props$square === void 0 ? false : _props$square,
      _props$backgroundClas = props.backgroundClass,
      backgroundClass = _props$backgroundClas === void 0 ? 'background-shade-30' : _props$backgroundClas,
      _props$borderClass = props.borderClass,
      borderClass = _props$borderClass === void 0 ? props.noBorder ? '' : 'border-small border-white' : _props$borderClass,
      _props$colorClass = props.colorClass,
      colorClass = _props$colorClass === void 0 ? 'white' : _props$colorClass;
  var base = [CLASSNAMES[size], 'avatar', ['height-full width-full', 'font-weight-medium', 'background-cover background-center background-no-repeat', backgroundClass, colorClass, borderClass, className], {
    'radius-round': !square,
    'radius-small': square
  }];

  if (url) {
    return classNames(base, ['height-full width-full', 'background-cover background-center background-no-repeat']);
  } else {
    return classNames(base, ['flexbox flexbox-centered', 'capitalize font-weight-large']);
  }
}

var shorten = function shorten(_ref) {
  var name = _ref.name,
      letters = _ref.letters;
  return name.replace(/[^a-zA-Z0-9\s:]*/g, '').slice(0, letters);
};

export default function Avatar(props) {
  var name = props.name,
      url = props.url,
      size = props.size,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style;
  var sizeStyle = STYLES[size];
  var className = getClassNamesForProps(props);
  var content = null;

  var componentStyle = _objectSpread({}, sizeStyle, {
    backgroundImage: "url(".concat(url, ")")
  }, style);

  if (!url) {
    content = shorten({
      name: name,
      letters: size === 'xs' ? 1 : 2
    });
    componentStyle = _objectSpread({}, sizeStyle, {
      lineHeight: "".concat(SIZES[size], "px")
    }, style);
  }

  return React.createElement("div", {
    className: className,
    style: componentStyle
  }, content);
}
Avatar.propTypes = {
  name: PropTypes.string.isRequired,
  url: PropTypes.string,
  size: PropTypes.oneOf(Object.keys(SIZES)),
  style: PropTypes.object
};
Avatar.defaultProps = {
  size: 'base'
};